// packages/web/src/api/me/query-options.ts
import { queryOptions } from "@tanstack/react-query";
import { meMfaSetup, meWeek } from "../generated/sdk.gen.ts";
import { queryKeys } from "../query-keys.ts";
import { meKeys } from "./keys.ts";

export const mfaSetupOptions = () =>
  queryOptions({
    queryKey: queryKeys.me.mfaSetup(),
    queryFn: async () => {
      const { data, error } = await meMfaSetup();
      if (error) throw error;
      return data;
    },
  });

export function workerWeekOptions(userId: string, weekISO: string) {
  return queryOptions({
    queryKey: meKeys.week(userId, weekISO),
    queryFn: async () => {
      const { data, error } = await meWeek({ path: { weekISO } });
      if (error) throw error;
      if (!data) throw new Error("Failed to load week");
      return data;
    },
    staleTime: 30_000,
  });
}
